<!-- 这个一个带展开行的表格组件 -->
<template>
    <div id="n-table">
        <div
            v-if="tableList.showOtpColumnConfig"
            class="setting-box"
            @click="openColumnConfig">
            <i class="el-icon-setting"></i>
        </div>
        <!-- 列配置--原有组件 -->
        <otpColumnConfig
            ref="otpColumnConfig"
            :initColumns="tableConfigList"
            @getTableConfigList="getTableConfigList"></otpColumnConfig>
        <el-table
            ref="moduleTable"
            :span-method="tableList.rowSpanMethod"
            border
            :key="tableKey"
            :highlight-current-row="tableList.highlight"
            :height="tableList.height"
            :data="tableData"
            :row-key="tableList.rowKey"
            :expand-row-keys="expandRowKeys"
            tooltip-effect="dark"
            v-loading="loading"
            @sort-change="handleSortChange"
            @current-change="handleCurrentChange"
            @select-all="selectAll"
            @selection-change="handleSelectionChange"
            @row-click="rowClick"
            @cell-click="cellClick"
            @row-dblclick="rowDBclick">
            <!-- 展开行 -->
            <el-table-column type="expand" v-if="tableList.expand" width="1">
                <template slot-scope="scope">
                    <slot name="table-expand" :props="{ ...scope }"></slot>
                </template>
            </el-table-column>
            <!-- 单选框 -->
            <el-table-column
                label=""
                align="center"
                v-if="tableList.radio"
                width="40">
                <template slot-scope="scope">
                    <el-radio
                        v-model="tableList.checked"
                        :label="scope.row.itemCode"></el-radio>
                </template>
            </el-table-column>
            <!-- 是否多选 selectBtn 实现多选非常简单: 手动添加一个el-table-column，设type属性为selection即可 -->
            <el-table-column
                type="selection"
                width="50"
                fixed
                v-if="tableList.selectBtn"></el-table-column>
            <el-table-column
                v-if="tableList.sequence"
                type="index"
                align="left"
                :label="
                    $translate('lang.E3202101260027', { defaultText: '序号' })
                "
                :fixed="true"
                width="50">
            </el-table-column>
            <!-- 下拉列表 -->
            <!-- 循环遍历展示 -->
            <el-table-column
                :show-overflow-tooltip="item.type === 'hint' ? false : true"
                v-for="item in tableConfigListShow"
                :key="item.prop"
                :prop="item.prop"
                :label="item.label"
                :fixed="item.fixed"
                :align="item.align"
                :sortable="item.sort"
                :min-width="item.width ? item.width : ''">
                <template slot="header" v-if="item.label">
                    <el-tooltip
                        class="item"
                        effect="dark"
                        :content="item.label"
                        placement="top-start">
                        <span>{{ item.label }}</span>
                    </el-tooltip>
                </template>
                <template slot-scope="scope">
                    <div v-if="item.type === 'switch'" @click="stopClick">
                        <el-switch
                            class="demo"
                            v-model="scope.row[item.prop]"
                            :disabled="scope.showScope"
                            @change="
                                switchChange(scope.row, item, scope.$index)
                            "
                            active-value="Y"
                            inactive-value="N"
                            :active-text="item.statesY"
                            :inactive-text="item.statesN">
                        </el-switch>
                    </div>
                    <div v-else-if="item.type === 'hint'">
                        <span
                            @click="
                                () =>
                                    handleView(scope.row[item.prop], item.label)
                            "
                            class="line-limit"
                            >{{ scope.row[item.prop] }}</span
                        >
                    </div>
                    <div v-else-if="item.type === 'underLine'">
                        <span
                            @click="() => handleDetail(scope.row)"
                            class="underLine"
                            >{{ scope.row[item.prop] }}</span
                        >
                    </div>
                    <div v-else-if="item.type === 'category'">
                        <slot
                            :name="`column-${item.prop}`"
                            :props="{ ...scope }"></slot>
                    </div>
                    <span
                        v-else
                        :style="{ color: scope.row[item.prop + 'Color'] }">
                        {{ scope.row[item.prop] }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column
                v-if="tableList.leftOperation || tableList.expand"
                :width="
                    tableList.leftOperationWidth
                        ? tableList.leftOperationWidth
                        : ''
                "
                fixed="right"
                :label="
                    $translate('lang.E3202102230005', { defaultText: '操作' })
                ">
                <template slot-scope="scope">
                    <el-button
                        v-if="tableList.expand && scope.row.isExpand"
                        @click.stop="
                            setExpandRowKeys(scope.row[tableList.rowKey], scope.row.sourceBillNo)
                        "
                        type="text"
                        size="mini">
                        <img
                            src="../../assets/images/icon-expend.png"
                            style="width: 16px" />
                    </el-button>
                    <el-button
                        v-for="(item, index) in tableList.action"
                        :key="index"
                        @click.stop="
                            btnEvent(scope.row, scope.$index, item.event)
                        "
                        :type="item.type || 'text'"
                        size="mini">
                        <i :class="item.icon" style="font-size: 16px"></i>
                        {{ item.label }}
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-dialog :title="title" :visible.sync="dialogVisible" width="40%">
            <!-- <pre v-for="(item,index) in params" :key="index" class="show-json">{{item}}</pre> -->
            <div class="dialogVisible">{{ params }}</div>
        </el-dialog>
    </div>
</template>
<script>
/**
 * @description 通用表单组件
 * @property {Object} showOtpColumnConfig 显示列配置
 * @property {Boolean} highlight 高亮
 * @property {String} hight 高度
 * @property {Number} expandNumber 展开行高度
 * @
 * **/
import otpColumnConfig from '@/components/lots/otpColumnConfig/index.vue';
export default {
    components: {
        otpColumnConfig
    },
    props: {
        tableList: {
            type: Object,
            default() {
                return {
                    highlight: false
                };
            }
        },
        loading: {
            type: Boolean,
            default() {
                return false;
            }
        },
        tableData: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            tableKey: 1,
            checkedList: '',
            // 选中
            selectedRowsData: [],
            expandRowKeys: [],
            dialogVisible: false,
            params: '',
            title: '',
            tableConfigList: []
        };
    },
    computed: {
        tableConfigListShow() {
            return this.tableConfigList.filter(
                (item) => !item.hiddenColumn && !item.isHidden
            );
        }
    },
    created() {
        this.tableConfigList = this.tableList.columns;
    },
    mounted() {
        // this.$refs.otpColumnConfig.show(true)
        // console.log(this.tableList);
    },
    methods: {
        getTableConfigList(data) {
            this.tableConfigList = data;
            this.$emit('getTableConfigList', data);
            this.$nextTick(() => {
                this.tableKey++;
            });
        },
        tableConfigClose() {},
        handleDetail(data) {
            this.$emit('handleDetail', data);
        },
        handleView(data, label) {
            this.params = '';
            this.title = '';
            this.dialogVisible = true;
            this.params = data;
            this.title = label;
        },
        // 启用停用
        switchChange(data, item, num) {
            if (this.tableList.switchType) {
                this.$emit('switch-change', data);
            } else {
                if (data[item.prop] === 'Y') {
                    this.$confirm('是否启用?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消'
                    })
                        .then(() => {
                            // this.$message({
                            //     type: 'success',
                            //     message: '启用成功!'
                            // });
                            this.$emit('switch-change', data);
                        })
                        .catch(() => {
                            this.tableData[num][item.prop] = 'N';
                        });
                } else {
                    this.$confirm('是否停用?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消'
                    })
                        .then(() => {
                            // this.$message({
                            //     type: 'success',
                            //     message: '停用成功!'
                            // });
                            this.$emit('switch-change', data);
                        })
                        .catch(() => {
                            this.tableData[num][item.prop] = 'Y';
                        });
                }
            }
        },
        selectAll() {
            if (this.tableList.isSingleSelect) {
                this.$refs.moduleTable.clearSelection();
            }
        },
        handleSelectionChange(selection) {
            if (this.tableList.isSingleSelect && selection.length >= 2) {
                const removeItem = selection[0];
                this.$refs.moduleTable.toggleRowSelection(removeItem);
                this.selectedRowsData = selection.splice(0, 1);
            } else {
                this.selectedRowsData = selection;
            }
            this.$emit('onSelectionChange', selection);
        },
        handleSelection(selection) {
            selection.forEach(element => {
                this.$refs.moduleTable.toggleRowSelection(element);
            });
        },
        rowClick(row) {
            if (
                this.tableList.selectBtn &&
                this.selectedRowsData.includes(row)
            ) {
                this.$refs.moduleTable.toggleRowSelection(row, false);
            } else {
                this.$refs.moduleTable.toggleRowSelection(row, true);
            }

            this.$emit('rowClick', row);
        },
        cellClick(row, column) {
            const params = {
                ...row,
                property: column.property,
                label: column.label
            };
            this.$emit('cellClick', params);
        },
        setExpandRowKeys(key, sourceBillNo) {
            if (this.tableList.expand) {
                if (this.expandRowKeys.includes(key)) {
                    this.expandRowKeys = this.expandRowKeys.filter(
                        (item) => item !== key
                    );
                } else {
                    this.expandRowKeys = [...this.expandRowKeys, key].slice(
                        -this.tableList.expandNumber
                    );
                    this.$el.querySelector(
                        '.el-table__body-wrapper'
                    ).scrollLeft = 0;
                }
            }
            this.$emit('expandRowKeysChange', this.expandRowKeys, sourceBillNo);
        },
        rowDBclick(data) {
            this.$emit('rowDBclick', data);
        },
        handleCurrentChange(data) {
            this.$emit('handleCurrentChange', data);
        },
        handleSortChange(data) {
            this.$emit('handleSortChange', data);
        },
        stopClick() {
            event.stopPropagation();
        },
        // 操作
        btnEvent(selection, index, event) {
            this.$emit('btn-event', selection, index, event);
        },
        openColumnConfig() {
            this.$refs.otpColumnConfig.show(true);
        }
    }
};
</script>
<style lang="less" scoped>
#n-table {
    position: relative;
    .setting-box {
        position: absolute;
        top: -30px;
        right: 0;
        padding: 3px;
        border: 1px solid #999;
        border-radius: 5px;
    }
    .item {
        height: 30px;
    }
    .line-limit {
        color: #4285f5;
        cursor: pointer;
    }
    .underLine {
        color: #4285f5;
        cursor: pointer;
        text-decoration: underline;
    }
    .dialogVisible {
        height: 30vh;
        overflow: auto;
    }
    /deep/.el-table__expanded-cell {
        border-left: 5px solid #4285f5 !important;
    }
    /deep/ .el-table__body-wrapper .el-table__expanded-cell {
        z-index: 100;
    }
    /deep/ .el-table__expanded-cell:hover {
        background-color: #fff !important;
    }
    /deep/ .el-table__fixed {
        height: auto !important;
        bottom: 10px !important;
    }
}
</style>
